/* eslint-disable no-unused-vars */
import { useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Table from "../../../components/Table/Table";
import { Header } from "../../../components";
import { PerformerRejectedBaseColumns } from "../../../utils/utils";
import TicketButton from "../../../components/TableComponents/TicketButton/TicketButton";
import TableLayout from "../../../layouts/TableLayout/TableLayout";
import useTicketData from "../../../hooks/useTicketData";
import useTicketFilters from "../../../utils/ticketFilters";
import ActionButtons from "../../../components/TableComponents/ActionButtons/ActionButtons";
import { ROUTES } from "../../../constants";
import useTicketExport from "../../../hooks/useTicketExport";
import NoItemsFound from "../../../components/NoItemsFound/NoItemsFound";

function Rejected() {
  const history = useHistory();

  // Custom hooks
  const {
    searchQuery,
    allRows:filteredRows,
    loading,
    isRefreshing,
    handleRefresh,
    handleSearchQuery,
    total,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  } = useTicketData("APPROVER_REJECTED", true);


  const handleActionClick = useCallback((action, rowData) => {
    if (action === "Resubmit") {
      // Handle the action for resubmitting the ticket
     history.push(
             ROUTES.GOTOQUESTIONNAIRE(rowData.id, rowData.ticketNumber, "resubmit")
           );
    }

  }, []);

  // Column configuration
  const columns = useMemo(() => {
    const updatedColumns = [...PerformerRejectedBaseColumns];

    updatedColumns[0] = {
      width: 280,
      title: "Ticket Number",
      field: "ticketNumber",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => <TicketButton ticketNumber={rowData.ticketNumber} ticketId={rowData.id} />,
    };

    updatedColumns[3] = {
      width: 150,
      title: "Updated On",
      field: "updatedOn",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => {
        if (!rowData.updatedOn) return null;

        const date = new Date(rowData.updatedOn);
        const formattedDate = date.toLocaleString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        return <div style={{ color: "#1F1F1F" }}>{formattedDate.replace(",", "")}</div>;
      },
    };
    updatedColumns[6] = {
      width: 150,
      title: "Action",
      field: "action",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <ActionButtons
          actions={["Resubmit"]}
          status={rowData.status}
          onActionClick={(action) => handleActionClick(action, rowData)}
        />
      ),
    };
    return updatedColumns;
  }, [handleActionClick]);

  const {handleExport,isExporting}=useTicketExport("APPROVER_REJECTED",columns)

  return (
    <TableLayout
      styles={{ tableInnerWrapper: { paddingBottom: "0rem" } }}
      header={
        <Header
          searchQuery={searchQuery}
          handleSearchQuery={handleSearchQuery}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          onExport={handleExport}
          isExporting={isExporting}
          disableExport={filteredRows.length === 0}
        />
      }
    >
      {filteredRows.length === 0 && !(loading) ? (
        <NoItemsFound />
      ) : (
        <Table
          columns={columns}
          defaultColumns={columns}
          rows={filteredRows}
          hideCheckbox
          rowHeight={45}
          setHasActiveEdits={() => {}}
          isDataLoading={loading || isRefreshing}
          serverSide
          totalRows={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </TableLayout>
  );
}

export default Rejected;
